import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../assets/svg/contact-center.svg',
})
export class ContactCenterComponent {}
